import aws from "assets/img/common/aws-logo.png";

export const coursesPartner = {
  title: "Bootcamp created in collaboration with engineers at:",
  logos: [{ img: aws, alt: "AWS" }],
};
